import styled from "styled-components";

interface ContainerProps {
  $ungrouped: boolean;
}

const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 14px;
  padding: 18px 20px 20px;
  border-radius: 12px;
  background: #fff;
  border: 1px ${(props) => (props.$ungrouped ? "dashed" : "solid")}
    ${(props) => (props.$ungrouped ? props.theme.brand.line : "#e8edf3")};
  box-shadow: ${(props) => (props.$ungrouped ? "none" : "0 1px 4px rgba(0, 53, 99, 0.06)")};
  transition: box-shadow 0.15s, border-color 0.15s, transform 0.15s;

  ${(props) => !props.$ungrouped && `
    &:hover {
      box-shadow: 0 6px 18px rgba(0, 53, 99, 0.13);
      border-color: #c0cfe0;
      transform: translateY(-2px);
    }
  `}
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  svg {
    width: 20px;
    height: 20px;
  }
  .MuiIconButton-root {
    padding: 0;
    color: ${({ theme }) => theme.brand.navy};

    &.no-permission {
      cursor: not-allowed !important;
      pointer-events: auto !important;
    }
  }
`;

interface NameGroupProps {
  $ungrouped: boolean;
}

const NameGroup = styled.div<NameGroupProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;

  span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 600;
    font-size: 13px;
    letter-spacing: 0.05em;
    color: ${(props) => (props.$ungrouped ? props.theme.brand.soft : "#3a4a5c")};
  }
`;

interface SwatchProps {
  $color: string;
}

const Swatch = styled.span<SwatchProps>`
  width: 10px;
  height: 10px;
  flex-shrink: 0;
  border-radius: 2px;
  background: ${(props) => props.$color};
`;

const Meta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

const Count = styled.span`
  font-size: 11px;
  color: ${({ theme }) => theme.brand.soft};
  white-space: nowrap;
`;

const Users = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
  gap: 12px;
  row-gap: 10px;
  min-height: 85px;
`;

export { Container, Header, NameGroup, Swatch, Meta, Count, Users };
